import { render } from "./Relations.vue?vue&type=template&id=48cee4e6&scoped=true"
import script from "./Relations.vue?vue&type=script&lang=js"
export * from "./Relations.vue?vue&type=script&lang=js"

import "./Relations.vue?vue&type=style&index=0&id=48cee4e6&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cee4e6"]])

export default __exports__